import React, { useState } from 'react';

import { Box, Loader, Paper, Stack, Text, TextInput, Title, UnstyledButton } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconSearch } from '@tabler/icons-react';
import useTags from 'hooks/glmFlows/useTags';

import { useGLMCardStyles } from '../styles';
import { FormValues } from '../types';

interface IKiloGLMTagSelectProps {
  handleTagSelect: (value: string[]) => void;
  form: UseFormReturnType<FormValues, (values: FormValues) => FormValues>;
}

const KiloGLMTagSelect = ({ handleTagSelect, form }: IKiloGLMTagSelectProps): JSX.Element => {
  const { classes, cx } = useGLMCardStyles();
  const { data: tagsData, isLoading } = useTags();
  const [search, setSearch] = useState('');

  const tags: string[] = Array.isArray(tagsData) ? tagsData : [];
  const filteredTags = search ? tags.filter(tag => tag.toLowerCase().includes(search.toLowerCase())) : tags;

  const toggleTag = (tag: string): void => {
    const current = form.values.tags || [];
    const updated = current.includes(tag) ? current.filter(v => v !== tag) : [...current, tag];
    form.setFieldValue('tags', updated);
    handleTagSelect(updated);
  };

  return (
    <Paper>
      <Stack sx={{ paddingTop: '20px' }}>
        <Title order={3}>Select Tags</Title>
        <Text size={15}>Select the tags to be added to the athlete contact in Gym Lead Machine.</Text>
        <TextInput
          placeholder='Search tags'
          value={search}
          onChange={e => setSearch(e.currentTarget.value)}
          icon={<IconSearch size={14} />}
        />
        {isLoading ? (
          <Stack align='center' py='md'>
            <Loader size='sm' />
          </Stack>
        ) : (
          <Stack spacing={6}>
            {filteredTags.map(tag => {
              const isSelected = (form.values.tags || []).includes(tag);
              return (
                <UnstyledButton key={tag} onClick={() => toggleTag(tag)}>
                  <Box className={cx(classes.card, { [classes.cardSelected]: isSelected })}>
                    <Text weight={isSelected ? 600 : 400}>{tag}</Text>
                  </Box>
                </UnstyledButton>
              );
            })}
            {filteredTags.length === 0 && (
              <Text size='sm' color='dimmed'>
                No tags found
              </Text>
            )}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};

export default KiloGLMTagSelect;
